import { API_BASE_URL } from "src/config/api";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { Buffer } from 'buffer';
import { Dialog, IconButton, Box, Button, Stack, Grid, Typography, CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import Iframe from 'react-iframe';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import CloseIcon from '@mui/icons-material/Close';

import TimeIntervalDropdown from '../TimeIntervalDropDown';
// import CustomTimeRangePopup from '../CustomTimeRangePopup';

const iframeTitle = {
  color: 'black',
  textDecoration: 'none',
  fontSize: 'larger',
  fontWeight: 'bold',
};
const iframDivStyle = {
  marginLeft: '7px',
};
export default function LinuxOrMac() {
  const navigate = useNavigate();
  const [isLoadingCount, setIsLoadingCount] = useState(23); //  23 is the total number of iframe
  const [isFirstDivCollapsed, setIsFirstDivCollapsed] = useState(false);
  const token = localStorage.getItem('token');
  const [isSecondDivCollapsed, setIsSecondDivCollapsed] = useState(false);
  const [isThirdDivCollapsed, setIsThirdDivCollapsed] = useState(false);
  const [isFourthDivCollapsed, setIsFourthDivCollapsed] = useState(false);
  const [isFifthDivCollapsed, setIsFifthDivCollapsed] = useState(false);
  const [isSixthDivCollapsed, setIsSixthDivCollapsed] = useState(false);
  const currentTimeInMilliseconds = new Date().getTime();
  const [startTime, setStartTime] = useState(currentTimeInMilliseconds - 5 * 60 * 1000);
  const [endTime, setEndTime] = useState(currentTimeInMilliseconds);
  // const [showCustomPopup, setShowCustomPopup] = useState(false);
  const [grafanaToken, setGrafanaToken] = useState();

  const [fullscreenSrc, setFullscreenSrc] = useState('');
  const [isFullscreenOpen, setIsFullscreenOpen] = useState(false);
  const [hoveredPanel, setHoveredPanel] = useState(null);

  const { encodedParams } = useParams();
  let decodedParams = {};

  try {
    const decoded = JSON.parse(Buffer.from(encodedParams, 'base64').toString('utf-8'));
    decodedParams = decoded;
  } catch (e) {
    console.error('Invalid URL parameters');
  }

  const { dashboardName, userName, ipAddress, typeOfOS, portAddress, dataRetentionDays } = decodedParams;
  useEffect(() => {
    if (typeOfOS !== 'linuxOrMac') {
      navigate(`/dashboard/monitors`);
      return
    }

    fetchGrafanaToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startTime, endTime]);

  const fetchGrafanaToken = async () => {
    try {
      const cleanToken = token.replace(/"/g, '');
      const config = {
        headers: {
          Authorization: `Bearer ${cleanToken}`,
        },
      };
      const response = await axios.get(`${API_BASE_URL}/createGrafanaToken`, config);
      if (response.data.success === true) {
        setGrafanaToken(response.data.token);
      }
    } catch (error) {
      console.error('Error fetching token', error);
    }
  };
  const handleRefreshClick = () => {
    fetchGrafanaToken();
  };

  const handleIntervalSelect = (selectedInterval) => {
    setIsLoadingCount(23);
    const intervalInMilliseconds = selectedInterval * 60 * 1000;
    setStartTime(currentTimeInMilliseconds - intervalInMilliseconds);
    setEndTime(currentTimeInMilliseconds);
  };
  // const handleShowCustomPopup = () => {
  //   setShowCustomPopup(true);
  // };

  const handleApplyButtonClick = (newStartTime, newEndTime) => {
    setIsLoadingCount(23);
    setStartTime(newStartTime);
    setEndTime(newEndTime);
  };
  const toggleFirstCollapse = () => {
    setIsFirstDivCollapsed(!isFirstDivCollapsed);
  };
  const toggleSecondCollapse = () => {
    setIsSecondDivCollapsed(!isSecondDivCollapsed);
  };
  const toggleThirdCollapse = () => {
    setIsThirdDivCollapsed(!isThirdDivCollapsed);
  };
  const toggleFourthCollapse = () => {
    setIsFourthDivCollapsed(!isFourthDivCollapsed);
  };
  const toggleFifthCollapse = () => {
    setIsFifthDivCollapsed(!isFifthDivCollapsed);
  };
  const toggleSixthCollapse = () => {
    setIsSixthDivCollapsed(!isSixthDivCollapsed);
  };
  const handleIframeLoad = () => {
    setIsLoadingCount((prevCount) => prevCount - 1);
  };

  const handleOpenFullscreen = (src) => {
    setFullscreenSrc(src);
    setIsFullscreenOpen(true);
  };

  const handleCloseFullscreen = () => {
    setIsFullscreenOpen(false);
    setFullscreenSrc('');
  };


  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h3" gutterBottom>
          Node Metrics
        </Typography>
        <Stack direction="row" spacing={2}>
          <TimeIntervalDropdown onSelect={handleIntervalSelect} dataRetentionDays={dataRetentionDays} />
          {/* <Button variant="outlined" color="primary" onClick={handleShowCustomPopup}>
            Select Custom Time
          </Button> */}
          <Button
            variant="contained"
            startIcon={<RefreshIcon />}
            onClick={handleRefreshClick}
            color='primary'
            sx={{
              textTransform: 'none',
              borderRadius: '8px',
              paddingX: 2,
              paddingY: 0.8,
              minWidth: '100px',
              
            }}
          >
            Refresh
          </Button>

          {/* {showCustomPopup && (
            <CustomTimeRangePopup
              open={showCustomPopup}
              onClose={() => {
                setShowCustomPopup(false);
              }}
              onApply={handleApplyButtonClick}
            />
          )} */}
        </Stack>
      </Stack>
      {isLoadingCount > 0 && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '110%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999,
          }}
        >
          <CircularProgress color="primary" />
        </div>
      )}
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <a href="#" onClick={toggleFirstCollapse} style={iframeTitle}>
            Quick CPU / Mem / Disk
          </a>
        </AccordionSummary>
        <AccordionDetails>
          {!isFirstDivCollapsed && (
            <Grid container>
              {[20, 155, 16, 21, 154].map((panelId) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={panelId}>
                  <div style={iframDivStyle}>
                    {/* <Box
                      position="relative"
                      onMouseEnter={() => setHoveredPanel(panelId)}
                      onMouseLeave={() => setHoveredPanel(null)}
                    > */}
                    <Iframe
                      title={`graph-${panelId}`}
                      src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/rYdddlPWk/${dashboardName}?orgId=1&refresh=1m&var-datasource=d42661db-afb2-49d7-bea2-6dc6b14b7168&var-job=${userName}&var-node=${ipAddress}%3A${portAddress}&var-diskdevices=%5Ba-z%5D%2B%7Cnvme%5B0-9%5D%2Bn%5B0-9%5D%2B%7Cmmcblk%5B0-9%5D%2B&from=${startTime}&to=${endTime}&theme=light&panelId=${panelId}&auth_token=${grafanaToken}`}
                      width="100%"
                      height={200}
                      frameBorder={1}
                      onLoad={handleIframeLoad}
                    />
                    {/* {hoveredPanel === panelId && (
                        <IconButton
                          onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/rYdddlPWk/${dashboardName}?orgId=1&refresh=1m&var-datasource=d42661db-afb2-49d7-bea2-6dc6b14b7168&var-job=${userName}&var-node=${ipAddress}%3A${portAddress}&var-diskdevices=%5Ba-z%5D%2B%7Cnvme%5B0-9%5D%2Bn%5B0-9%5D%2B%7Cmmcblk%5B0-9%5D%2B&from=${startTime}&to=${endTime}&theme=light&panelId=${panelId}&auth_token=${grafanaToken}`)}
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'rgba(130, 130, 130, 0.6)',
                            color: 'white',
                            zIndex: 2,
                            '&:hover': {
                              backgroundColor: 'rgba(164, 164, 164, 0.8)',
                            },
                          }}
                        >
                          <FullscreenIcon />
                        </IconButton>
                      )}
                    </Box> */}

                  </div>
                </Grid>
              ))}
            </Grid>
          )}
          {!isFirstDivCollapsed && (
            <Grid container>
              {[14, 15, 23, 75, 18].map((panelId) => (
                <Grid item xs={4} sm={3} md={3} lg={2} key={panelId}>
                  <div style={iframDivStyle}>
                    {/* <Box
                      position="relative"
                      onMouseEnter={() => setHoveredPanel(panelId)}
                      onMouseLeave={() => setHoveredPanel(null)}
                    > */}
                    <Iframe
                      title={`graph-${panelId}`}
                      src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/rYdddlPWk/${dashboardName}?orgId=1&refresh=1m&var-datasource=d42661db-afb2-49d7-bea2-6dc6b14b7168&var-job=${userName}&var-node=${ipAddress}%3A${portAddress}&var-diskdevices=%5Ba-z%5D%2B%7Cnvme%5B0-9%5D%2Bn%5B0-9%5D%2B&from=${startTime}&to=${endTime}&theme=light&panelId=${panelId}&auth_token=${grafanaToken}`}
                      width="100%"
                      height={200}
                      frameBorder={1}
                      onLoad={handleIframeLoad}
                    />
                    {/* {hoveredPanel === panelId && (
                        <IconButton
                          onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/rYdddlPWk/${dashboardName}?orgId=1&refresh=1m&var-datasource=d42661db-afb2-49d7-bea2-6dc6b14b7168&var-job=${userName}&var-node=${ipAddress}%3A${portAddress}&var-diskdevices=%5Ba-z%5D%2B%7Cnvme%5B0-9%5D%2Bn%5B0-9%5D%2B&from=${startTime}&to=${endTime}&theme=light&panelId=${panelId}&auth_token=${grafanaToken}`)}
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'rgba(130, 130, 130, 0.6)',
                            color: 'white',
                            zIndex: 2,
                            '&:hover': {
                              backgroundColor: 'rgba(164, 164, 164, 0.8)',
                            },
                          }}
                        >
                          <FullscreenIcon />
                        </IconButton>
                      )} */}
                    {/* </Box> */}
                  </div>
                </Grid>
              ))}
            </Grid>
          )}
        </AccordionDetails>

      </Accordion>
      <Accordion >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <a href="#" onClick={toggleSecondCollapse} style={iframeTitle}>
            CPU / Memory / Net / Disk
          </a>
        </AccordionSummary>
        <AccordionDetails>
          {isSecondDivCollapsed ? null : (
            <Grid container>
              {[3, 24, 84, 156, 229, 42, 127].map((panelId) => (
                <Grid item xs={12} sm={12} md={12} lg={6} key={panelId}>
                  <div style={iframDivStyle}>
                    <Box
                      position="relative"
                      onMouseEnter={() => setHoveredPanel(panelId)}
                      onMouseLeave={() => setHoveredPanel(null)}
                    >
                      <Iframe
                        title={`graph-${panelId}`}
                        src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/rYdddlPWk/${dashboardName}?orgId=1&refresh=1m&var-datasource=d42661db-afb2-49d7-bea2-6dc6b14b7168&var-job=${userName}&var-node=${ipAddress}%3A${portAddress}&var-diskdevices=%5Ba-z%5D%2B%7Cnvme%5B0-9%5D%2Bn%5B0-9%5D%2B%7Cmmcblk%5B0-9%5D%2B&from=${startTime}&to=${endTime}&theme=light&panelId=${panelId}&auth_token=${grafanaToken}`}
                        width="100%"
                        height={200}
                        frameBorder={1}
                        onLoad={handleIframeLoad}
                      />
                      {hoveredPanel === panelId && (
                        <IconButton
                          onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/rYdddlPWk/${dashboardName}?orgId=1&refresh=1m&var-datasource=d42661db-afb2-49d7-bea2-6dc6b14b7168&var-job=${userName}&var-node=${ipAddress}%3A${portAddress}&var-diskdevices=%5Ba-z%5D%2B%7Cnvme%5B0-9%5D%2Bn%5B0-9%5D%2B%7Cmmcblk%5B0-9%5D%2B&from=${startTime}&to=${endTime}&theme=light&panelId=${panelId}&auth_token=${grafanaToken}`)}
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'rgba(130, 130, 130, 0.6)',
                            color: 'white',
                            zIndex: 2,
                            '&:hover': {
                              backgroundColor: 'rgba(164, 164, 164, 0.8)',
                            },
                          }}
                        >
                          <FullscreenIcon />
                        </IconButton>
                      )}
                    </Box>
                  </div>
                </Grid>
              ))}
            </Grid>
          )}
        </AccordionDetails>
      </Accordion>
      <Accordion >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3-content"
          id="panel3-header"
        >
          <a href="#" onClick={toggleThirdCollapse} style={iframeTitle}>
            System Processes
          </a>
        </AccordionSummary>
        <AccordionDetails>
          {isThirdDivCollapsed ? null : (
            <Grid container>
              {[62].map((panelId) => (
                <Grid item xs={12} sm={12} md={12} lg={12} key={panelId}>
                  <div style={iframDivStyle}>
                    <Box
                      position="relative"
                      onMouseEnter={() => setHoveredPanel(panelId)}
                      onMouseLeave={() => setHoveredPanel(null)}
                    >
                      <Iframe
                        title={`graph-${panelId}`}
                        src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/rYdddlPWk/${dashboardName}?orgId=1&refresh=1m&var-datasource=d42661db-afb2-49d7-bea2-6dc6b14b7168&var-job=${userName}&var-node=${ipAddress}%3A${portAddress}&var-diskdevices=%5Ba-z%5D%2B%7Cnvme%5B0-9%5D%2Bn%5B0-9%5D%2B%7Cmmcblk%5B0-9%5D%2B&from=${startTime}&to=${endTime}&theme=light&panelId=${panelId}&auth_token=${grafanaToken}`}
                        width="100%"
                        height={200}
                        frameBorder={1}
                        onLoad={handleIframeLoad}
                      />
                      {hoveredPanel === panelId && (
                        <IconButton
                          onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/rYdddlPWk/${dashboardName}?orgId=1&refresh=1m&var-datasource=d42661db-afb2-49d7-bea2-6dc6b14b7168&var-job=${userName}&var-node=${ipAddress}%3A${portAddress}&var-diskdevices=%5Ba-z%5D%2B%7Cnvme%5B0-9%5D%2Bn%5B0-9%5D%2B%7Cmmcblk%5B0-9%5D%2B&from=${startTime}&to=${endTime}&theme=light&panelId=${panelId}&auth_token=${grafanaToken}`)}
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'rgba(130, 130, 130, 0.6)',
                            color: 'white',
                            zIndex: 2,
                            '&:hover': {
                              backgroundColor: 'rgba(164, 164, 164, 0.8)',
                            },
                          }}
                        >
                          <FullscreenIcon />
                        </IconButton>
                      )}
                    </Box>
                  </div>
                </Grid>
              ))}
            </Grid>
          )}
        </AccordionDetails>
      </Accordion>
      <Accordion >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4-content"
          id="panel4-header"
        >
          <a href="#" onClick={toggleFourthCollapse} style={iframeTitle}>
            System Misc
          </a>
        </AccordionSummary>
        <AccordionDetails>
          {isFourthDivCollapsed ? null : (
            <Grid container>
              {[7].map((panelId) => (
                <Grid item xs={12} sm={12} md={12} lg={12} key={panelId}>
                  <div style={iframDivStyle}>
                    <Box
                      position="relative"
                      onMouseEnter={() => setHoveredPanel(panelId)}
                      onMouseLeave={() => setHoveredPanel(null)}
                    >
                      <Iframe
                        title={`graph-${panelId}`}
                        src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/rYdddlPWk/${dashboardName}?orgId=1&refresh=1m&var-datasource=d42661db-afb2-49d7-bea2-6dc6b14b7168&var-job=${userName}&var-node=${ipAddress}%3A${portAddress}&var-diskdevices=%5Ba-z%5D%2B%7Cnvme%5B0-9%5D%2Bn%5B0-9%5D%2B%7Cmmcblk%5B0-9%5D%2B&from=${startTime}&to=${endTime}&theme=light&panelId=${panelId}&auth_token=${grafanaToken}`}
                        width="100%"
                        height={200}
                        frameBorder={1}
                        onLoad={handleIframeLoad}
                      />
                      {hoveredPanel === panelId && (
                        <IconButton
                          onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/rYdddlPWk/${dashboardName}?orgId=1&refresh=1m&var-datasource=d42661db-afb2-49d7-bea2-6dc6b14b7168&var-job=${userName}&var-node=${ipAddress}%3A${portAddress}&var-diskdevices=%5Ba-z%5D%2B%7Cnvme%5B0-9%5D%2Bn%5B0-9%5D%2B%7Cmmcblk%5B0-9%5D%2B&from=${startTime}&to=${endTime}&theme=light&panelId=${panelId}&auth_token=${grafanaToken}`)}
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'rgba(130, 130, 130, 0.6)',
                            color: 'white',
                            zIndex: 2,
                            '&:hover': {
                              backgroundColor: 'rgba(164, 164, 164, 0.8)',
                            },
                          }}
                        >
                          <FullscreenIcon />
                        </IconButton>
                      )}
                    </Box>

                  </div>
                </Grid>
              ))}
            </Grid>
          )}
        </AccordionDetails>
      </Accordion>
      <Accordion >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5-content"
          id="panel5-header"
        >
          <a href="#" onClick={toggleFifthCollapse} style={iframeTitle}>
            Network Traffic
          </a>
        </AccordionSummary>
        <AccordionDetails>
          {isFifthDivCollapsed ? null : (
            <Grid container>
              {[60].map((panelId) => (
                <Grid item xs={12} sm={12} md={12} lg={12} key={panelId}>
                  <div style={iframDivStyle}>
                    <Box
                      position="relative"
                      onMouseEnter={() => setHoveredPanel(panelId)}
                      onMouseLeave={() => setHoveredPanel(null)}
                    >
                      <Iframe
                        title={`graph-${panelId}`}
                        src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/rYdddlPWk/${dashboardName}?orgId=1&refresh=1m&var-datasource=d42661db-afb2-49d7-bea2-6dc6b14b7168&var-job=${userName}&var-node=${ipAddress}%3A${portAddress}&var-diskdevices=%5Ba-z%5D%2B%7Cnvme%5B0-9%5D%2Bn%5B0-9%5D%2B%7Cmmcblk%5B0-9%5D%2B&from=${startTime}&to=${endTime}&theme=light&panelId=${panelId}&auth_token=${grafanaToken}`}
                        width="100%"
                        height={200}
                        frameBorder={1}
                        onLoad={handleIframeLoad}
                      />
                      {hoveredPanel === panelId && (
                        <IconButton
                          onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/rYdddlPWk/${dashboardName}?orgId=1&refresh=1m&var-datasource=d42661db-afb2-49d7-bea2-6dc6b14b7168&var-job=${userName}&var-node=${ipAddress}%3A${portAddress}&var-diskdevices=%5Ba-z%5D%2B%7Cnvme%5B0-9%5D%2Bn%5B0-9%5D%2B%7Cmmcblk%5B0-9%5D%2B&from=${startTime}&to=${endTime}&theme=light&panelId=${panelId}&auth_token=${grafanaToken}`)}
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'rgba(130, 130, 130, 0.6)',
                            color: 'white',
                            zIndex: 2,
                            '&:hover': {
                              backgroundColor: 'rgba(164, 164, 164, 0.8)',
                            },
                          }}
                        >
                          <FullscreenIcon />
                        </IconButton>
                      )}
                    </Box>
                  </div>
                </Grid>
              ))}
            </Grid>
          )}
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6-content"
          id="panel6-header"
        >
          <a href="#" onClick={toggleSixthCollapse} style={iframeTitle}>
            Network Sock-state
          </a>
        </AccordionSummary>
        <AccordionDetails>
          {isSixthDivCollapsed ? null : (
            <Grid container>
              {[63, 124, 220].map((panelId) => (
                <Grid item xs={12} sm={12} md={12} lg={6} key={panelId}>
                  <div style={iframDivStyle}>
                    <Box
                      position="relative"
                      onMouseEnter={() => setHoveredPanel(panelId)}
                      onMouseLeave={() => setHoveredPanel(null)}
                    >
                      <Iframe
                        title={`graph-${panelId}`}
                        src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/rYdddlPWk/${dashboardName}?orgId=1&refresh=1m&var-datasource=d42661db-afb2-49d7-bea2-6dc6b14b7168&var-job=${userName}&var-node=${ipAddress}%3A${portAddress}&var-diskdevices=%5Ba-z%5D%2B%7Cnvme%5B0-9%5D%2Bn%5B0-9%5D%2B%7Cmmcblk%5B0-9%5D%2B&from=${startTime}&to=${endTime}&theme=light&panelId=${panelId}&auth_token=${grafanaToken}`}
                        width="100%"
                        height={200}
                        frameBorder={1}
                        onLoad={handleIframeLoad}
                      />
                      {hoveredPanel === panelId && (
                        <IconButton
                          onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/rYdddlPWk/${dashboardName}?orgId=1&refresh=1m&var-datasource=d42661db-afb2-49d7-bea2-6dc6b14b7168&var-job=${userName}&var-node=${ipAddress}%3A${portAddress}&var-diskdevices=%5Ba-z%5D%2B%7Cnvme%5B0-9%5D%2Bn%5B0-9%5D%2B%7Cmmcblk%5B0-9%5D%2B&from=${startTime}&to=${endTime}&theme=light&panelId=${panelId}&auth_token=${grafanaToken}`)}
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'rgba(130, 130, 130, 0.6)',
                            color: 'white',
                            zIndex: 2,
                            '&:hover': {
                              backgroundColor: 'rgba(164, 164, 164, 0.8)',
                            },
                          }}
                        >
                          <FullscreenIcon />
                        </IconButton>
                      )}
                    </Box>

                  </div>
                </Grid>
              ))}
            </Grid>
          )}
        </AccordionDetails>
      </Accordion>

      <Dialog
        open={isFullscreenOpen}
        onClose={handleCloseFullscreen}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: '80vw',
            height: '80vh',
            maxWidth: 'none',
            position: 'relative', // needed for absolute children
            backgroundColor: 'black', // optional
          },
        }}
      >
        <IconButton
          onClick={handleCloseFullscreen}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'white',
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
        <Iframe
          src={fullscreenSrc}
          width="100%"
          height="100%"
          frameBorder={0}
          style={{ border: 'none' }}
        />
      </Dialog>
    </>
  );
}
